import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import isBoolean from 'lodash/isBoolean';
import Icon from '../icon';
import devWarning from '../_utils/devwarning';
export var CheckboxTypes = tuple('default', 'square');
export var CheckboxSizes = tuple('large', 'middle', 'small');

var InternalCheckbox = function InternalCheckbox(props, ref) {
  var _context, _context2, _context3, _classNames, _context4, _context5, _context6, _classNames2, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _classNames4, _context15, _context16, _context17, _classNames5, _context18;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var CheckboxProps = getCompProps('Checkbox', userDefaultProps, props);

  var checkboxType = CheckboxProps.checkboxType,
      className = CheckboxProps.className,
      customPrefixcls = CheckboxProps.prefixCls,
      defaultChecked = CheckboxProps.defaultChecked,
      checked = CheckboxProps.checked,
      size = CheckboxProps.size,
      onChange = CheckboxProps.onChange,
      disabled = CheckboxProps.disabled,
      children = CheckboxProps.children,
      style = CheckboxProps.style,
      value = CheckboxProps.value,
      indeterminate = CheckboxProps.indeterminate,
      name = CheckboxProps.name,
      rest = __rest(CheckboxProps, ["checkboxType", "className", "prefixCls", "defaultChecked", "checked", "size", "onChange", "disabled", "children", "style", "value", "indeterminate", "name"]);

  var getChecked = function getChecked() {
    return isBoolean(checked) ? checked : defaultChecked;
  };

  var _useState = useState(getChecked()),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var labelRef = useRef(null);
  devWarning(CheckboxTypes.indexOf(checkboxType) === -1, 'checkbox', "cannot found checkbox type '".concat(checkboxType, "'"));
  devWarning(CheckboxSizes.indexOf(size) === -1, 'checkbox', "cannot found size type '".concat(size, "'"));
  var checkboxPrefixCls = getPrefixCls(prefixCls, 'checkbox', customPrefixcls);

  var isDefaultType = function isDefaultType() {
    return checkboxType === 'default';
  };

  var getIndeterminate = function getIndeterminate() {
    return selected ? false : indeterminate;
  };

  var getDefaultClassName = classNames(className, (_classNames = {}, _defineProperty(_classNames, "".concat(checkboxPrefixCls), true), _defineProperty(_classNames, "".concat(checkboxPrefixCls, "-no-child"), !children), _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(checkboxPrefixCls, "-")).call(_context, size), true && !!children), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(checkboxPrefixCls, "-")).call(_context2, checkboxType), true), _defineProperty(_classNames, _concatInstanceProperty(_context3 = "".concat(checkboxPrefixCls, "-")).call(_context3, checkboxType, "-disabled"), disabled), _defineProperty(_classNames, "checked", selected), _classNames));
  var getSquareClassName = classNames(className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(checkboxPrefixCls), true), _defineProperty(_classNames2, _concatInstanceProperty(_context4 = "".concat(checkboxPrefixCls, "-")).call(_context4, checkboxType), true), _defineProperty(_classNames2, _concatInstanceProperty(_context5 = "".concat(checkboxPrefixCls, "-")).call(_context5, checkboxType, "-disabled"), disabled), _defineProperty(_classNames2, _concatInstanceProperty(_context6 = "".concat(checkboxPrefixCls, "-")).call(_context6, checkboxType, "-checked"), selected && !disabled), _defineProperty(_classNames2, "checked", selected), _classNames2));
  var getRootClassName = isDefaultType() ? getDefaultClassName : getSquareClassName;
  var inputClassName = classNames(_defineProperty({}, "".concat(checkboxPrefixCls, "-input"), true));
  var checkedWrapperClassName = classNames((_classNames4 = {}, _defineProperty(_classNames4, _concatInstanceProperty(_context7 = "".concat(checkboxPrefixCls, "-")).call(_context7, checkboxType, "-no-child"), !children), _defineProperty(_classNames4, _concatInstanceProperty(_context8 = "".concat(checkboxPrefixCls, "-")).call(_context8, checkboxType, "-wrapper"), true), _defineProperty(_classNames4, _concatInstanceProperty(_context9 = "".concat(checkboxPrefixCls, "-")).call(_context9, checkboxType, "-wrapper-size"), !!children), _defineProperty(_classNames4, _concatInstanceProperty(_context10 = "".concat(checkboxPrefixCls, "-")).call(_context10, checkboxType, "-margin"), !!children), _defineProperty(_classNames4, _concatInstanceProperty(_context11 = "".concat(checkboxPrefixCls, "-")).call(_context11, checkboxType, "-checked"), selected), _defineProperty(_classNames4, _concatInstanceProperty(_context12 = "".concat(checkboxPrefixCls, "-")).call(_context12, checkboxType, "-indeterminate"), getIndeterminate()), _defineProperty(_classNames4, _concatInstanceProperty(_context13 = "".concat(checkboxPrefixCls, "-")).call(_context13, checkboxType, "-disabled"), disabled && !selected), _defineProperty(_classNames4, _concatInstanceProperty(_context14 = "".concat(checkboxPrefixCls, "-")).call(_context14, checkboxType, "-checked-disabled"), disabled && selected), _classNames4));
  var triangleClassName = classNames((_classNames5 = {}, _defineProperty(_classNames5, _concatInstanceProperty(_context15 = "".concat(checkboxPrefixCls, "-")).call(_context15, checkboxType, "-triangle"), !selected), _defineProperty(_classNames5, _concatInstanceProperty(_context16 = "".concat(checkboxPrefixCls, "-")).call(_context16, checkboxType, "-triangle-checked"), selected), _defineProperty(_classNames5, _concatInstanceProperty(_context17 = "".concat(checkboxPrefixCls, "-")).call(_context17, checkboxType, "-triangle-disabled"), disabled), _classNames5));
  var innerIconClassName = classNames(_defineProperty({}, _concatInstanceProperty(_context18 = "".concat(checkboxPrefixCls, "-")).call(_context18, checkboxType, "-inner"), true));
  var handleChange = useCallback(function (e) {
    onChange && onChange(e);
    setSelected(e.target.checked);
  }, [onChange]);
  useEffect(function () {
    isBoolean(checked) && checked !== selected && setSelected(checked);
  }, [checked, selected]);
  useEffect(function () {
    var _a;

    var handleRepeatClick = function handleRepeatClick(e) {
      var element = e.target;

      if (element.tagName !== 'INPUT') {
        e.stopPropagation();
      }
    };

    (_a = labelRef === null || labelRef === void 0 ? void 0 : labelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', handleRepeatClick);
    return function () {
      var _a; // eslint-disable-next-line react-hooks/exhaustive-deps


      (_a = labelRef === null || labelRef === void 0 ? void 0 : labelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', handleRepeatClick);
    };
  }, []);

  var getDefaultCheckbox = function getDefaultCheckbox() {
    var _context19, _context20;

    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      React.createElement("label", _extends({
        className: getRootClassName,
        style: style,
        ref: labelRef
      }, rest), /*#__PURE__*/React.createElement("span", {
        className: checkedWrapperClassName
      }, selected && /*#__PURE__*/React.createElement("span", {
        className: innerIconClassName
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "right-bold",
        className: _concatInstanceProperty(_context19 = "".concat(checkboxPrefixCls, "-")).call(_context19, checkboxType, "-inner-icon")
      })), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        className: inputClassName,
        onChange: handleChange,
        ref: ref,
        value: value,
        checked: selected,
        disabled: disabled,
        name: name
      })), children && /*#__PURE__*/React.createElement("span", {
        className: "".concat(checkboxPrefixCls, "-children")
      }, children), !isDefaultType() && /*#__PURE__*/React.createElement("span", {
        className: triangleClassName
      }, /*#__PURE__*/React.createElement("span", {
        className: innerIconClassName
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "right-bold",
        className: _concatInstanceProperty(_context20 = "".concat(checkboxPrefixCls, "-")).call(_context20, checkboxType, "-inner-icon")
      }))))
    );
  };

  return getDefaultCheckbox();
};

var Checkbox = /*#__PURE__*/React.forwardRef(InternalCheckbox);
Checkbox.displayName = 'Checkbox';
export default Checkbox;